var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("A" + (_vm.name.substring(0,1).toUpperCase()+_vm.name.substring(1))),_vm._g(_vm._b({tag:"component",staticClass:"atom-icon",style:({'vertical-align': _vm.vAlign}),attrs:{"size":_vm.size}},'component',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-446ea9b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/Icon/Icon.vue
// module id = 212
// module chunks = 0